module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/journey.json
// module id = 393
// module chunks = 130348592575964